import Cookies from 'universal-cookie';
import I from 'immutable';
import { TOAST } from "../helpers/NotificationHelper";

// import MobileDetect from 'mobile-detect'

// const MD = new MobileDetect(window.navigator.userAgent)
// export const isMobile = () => MD.mobile()

export const setCookies = (name, value, expiry) => {
  const cookies = new Cookies();
  cookies.set(name, value, { maxAge: expiry || 1000000, path: '/' })
}
export const clearCookies = () => {
  const cookies = new Cookies();
  // cookies.set('token', '')
  cookies.remove('token')
  let c = cookies.getAll()
  Object.keys(c).forEach(element => {
    cookies.remove(element)
  })
  // Cookies.remove('token', { path: '/' })
}

export const getToken = () => {
  const cookies = new Cookies();
  return cookies.get('token')
}
export const getEventId = () => {
  const cookies = new Cookies();
  return cookies.get('eventId')
}

export const getEventLogo = () => {
  const cookies = new Cookies();
  return cookies.get('event_logo')
}
export const getCookies = (name) => {
  const cookies = new Cookies();
  return cookies.get(name)
}

export const updateListItem = (list, data, insert = false, id = 'id') => {
  let items = list
  let index = -1
  let existingItem = items.find((item, key) => {
    if (item.get(id).toString() === data.get(id).toString()) {
      index = key
      return true
    }
    return false
  })

  if (existingItem) {
    items = items.update(index, I.Map(), value =>
      value.mergeWith((oldVal, newVal) => {
        return newVal
      }, data)
    )
  } else {
    if (insert === true) {
      items = items.unshift(data)
    } else {
      console.log("Item not found")
    }

  }
  return items
}



export async function fetchData() {
  let t = await getToken();
  try {
    const response = await fetchSpeakers(t)
    setSpeakers(asImmutable(response))
    return response;
  } catch (error) {
    TOAST.error(error.message);
    return null;
  }
}

export const asImmutable = data => (I.isImmutable(data) ? data : I.fromJS(data))


export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);

    reader.onerror = (error) => reject(error);
  });

export const SnakeToCamel = str =>
  str && str.length > 0 ? (str.charAt(0).toUpperCase() + str.slice(1)).replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', ' ')
      .replace('_', ' ')
  ) : null;


export const UrlObjectReplace = (template, jsObject) => {
  return template.replace(/\${(.*?)}/g, (match, key) => {
    return jsObject[key] || match;
  });
}



export const errorsToForm = (e) => {
  const errors = asImmutable(e.response || {}).getIn(['data', 'errors'], I.List())
  if (errors.size > 0) {
    let c = Object.keys(errors.toJS()).map(x => {
      return ({ name: x, errors: errors.get(x, []).toJS() })
    })

    return c
  }

  return []
}

export const getHref = (x) => {

  if (x.href) {
    return x.href
  }

  switch (x.type) {

    case "exhibitor": return '/exhibitors/profile'
    case "exhibitor_badges": return '/exhibitors/badge'
    case "power_orders": return '/exhibitors/power_orders'
    case "product_index": return '/exhibitors/product_index'
    case "dynamic_form": return '/exhibitors/forms/' + x.edit_status.dynamic_form_group_id
    // default: return "#"
    default: return null
  }
}


export const mediaSizes = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};



export const makeError = (x) => {
  return x?.response?.status == 401 ? {
    redirect: {
      destination: "/logout",
    }
  } : x?.response?.status == 435 ? { //redirect manually
    redirect: {
      destination: x?.response?.data?.redirect,
    }
  } :
    x?.response?.status == 464 ?
      {
        redirect: {
          destination: "/event/profile?isEdit=true"
        }
      } : x?.response?.status == 404 ?
        { notFound: true } :
        {
          props: {
            error: {
              message: (x?.response?.data?.message),
              code: (x?.response?.status)
            }
          }
        }
}

export const youtube_parser = (url) => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match && match[7].length == 11) ? match[7] : false;
}

export function truncate(str) {
  return str?.length > 250 ? str.substring(0, 250) + "..." : str;
}

const debugEnabled = process.env.NEXT_PUBLIC_APP_DEBUG_ENABLE === 'true';

export const logger = (...args) => {
  if (debugEnabled) {
    console.log(...args);
  }
};


// utils/polyfilsResolver.js

/**
 * Polyfill for Promise.withResolvers if it's not available.
 */
export function polyfillPromiseWithResolvers() {
  if (!Promise.withResolvers) {
    Promise.withResolvers = function () {
      let resolve;
      let reject;

      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });

      return { promise, resolve, reject };
    };
  }
}

// Utility method to check if a cookie exists
export const cookieExists = (name) => {
  const cookies = new Cookies();
  return !!cookies.get(name);
};


export const dataURLToFile = (dataUrl, filename) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};


export const encodeBase64Url = (str) => {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

export const decodeBase64Url = (str) => {
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) {
    str += '=';
  }
  return atob(str);
};

// export const getSubdomainFromReq = (req) => {
//    return req?.cookies?.nevendo_client_code || req?.headers?.['x-subdomain'];
// }
export const getSubdomainFromCookie = () => {
  const cookies = new Cookies();

  return cookies.get('nevendo_client_code');
}

export const getSubdomainFromHost = (host) => {
  // return 'putech';
  const hostname = host.split(':')[0];
  if (hostname === 'localhost') return []

  // Handle *.localhost
  if (hostname.endsWith('.localhost')) {
    const sub = hostname.replace('.localhost', '')
    return sub.split('.') // supports multi-level like fafsi.event
  }

  // Normal domains
  const parts = hostname.split('.')[0]

  // if (parts.length <= 2) return []

  // Remove root domain (example.com)
  return parts;//.slice(0, -2)
}


export const getCookieClientConfig = () => {
  const clientCode = getCookies('nevendo_client_code');
  const clientConfig = getCookies('nevendo_client_config');
  if(!clientConfig){
    console.log("Cannot get clientConfig from cookie (nevendo_client_config)");
    return {};
  }
  const config = clientConfig[clientCode] ?? {};
  return config;
}

export class CustomError extends Error {
  status;

  constructor(message, status = 500) {
    super(message);
    this.status = status;
    this.name = "CustomError";
  }
}


export const _clientConfigValidate = async () => {
  try {
    const res = await fetch('/api/client-config-validate').then(e => e.json());
    if (typeof window !== 'undefined' && res?.status === 20) {
      window.location.href = '/logout';
      return;
    }
  }
  catch (e) {
    return false;
  }
}


// Utility method to set a cookie
export const setCookie = (name, value, options = {}) => {
  Cookies.set(name, value, {
    // Set default options or merge with provided options
    expires: 7, // Default expiration (7 days)
    secure: false, // Secure flag (only send over HTTPS)
    sameSite: 'Lax', // Default SameSite setting
    ...options, // Override defaults with custom options if provided
  });
};

export const triggerNativeShare = (title, url) => {
  if (window?.nevendo && window?.nevendo?.share) {
    try {
      window?.nevendo?.share("image", title, url);
    } catch (e) {
      console.log(e);
    }
  }
  else if (
    window?.webkit &&
    window?.webkit?.messageHandlers &&
    window?.webkit?.messageHandlers.nevendo
  ) {
    try {
      window?.webkit?.messageHandlers?.nevendo?.postMessage({
        type: "image",
        title: title,
        url: url,
      });
    }
    catch (e) {
      console.log(e);
    }
  }
};

export const triggerNativeActivity = (action, title, payload) => {
  if (window?.nevendo) {
    try {
      window?.nevendo?.openNativeScreenFromWebView(action, title, payload); // action String -> (title, profile_photo); title String?; payload String?
    } catch (e) {
      console.log("Failed to trigger android activity", e);
    }
  }
  else if (
    window?.webkit &&
    window?.webkit?.messageHandlers &&
    window?.webkit?.messageHandlers?.nevendo
  ) {
    try {
      window?.webkit?.messageHandlers?.nevendo?.postMessage({
        action: action,
        title: title,
        payload: payload,
      });
    }
    catch (e) {
      console.log("Failed to trigger ios activity", e);
    }
  }
  else {
    console.log("Failed to trigger activity. Platform not supported");
  }
};
